import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Hub, Learnspace, LearnspaceUserRole } from '@shared/models';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { ProgramTemplatePickerDialogComponent } from '../program-template-picker/program-template-picker-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'hub-home',
  templateUrl: './hub-home.component.html',
  styleUrls: ['./hub-home.component.scss']
})
export class HubHomeComponent implements OnInit {
  user: any | null;
  hub: Hub;
  isAdminOrManager = false;
  readonly contributorRole = LearnspaceUserRole.contributor;
  readonly learnerRole = LearnspaceUserRole.learner;
  undefined_url = 'assets/wonda/portrait.png';

  constructor(
    private _authService: AuthenticationService,
    private _currentHub: CurrentHubService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.user = await this._authService.getWondaUser();
    if (!this.user.photo) {
      this.user.photo = this.undefined_url;
    }
    this.hub = this._currentHub.hub;
    this.isAdminOrManager = this._currentHub.canManageCurrentHub();
  }

  onContributeCardClick(ls: Learnspace): void {
    this._router.navigate(['/', this._currentHub.getHubURLTitle(), ls.id]);
  }

  onPractiseCardClick(ls: Learnspace): void {
    this._router.navigate([], { relativeTo: this._route, queryParams: { pl: ls.id } });
  }

  onContributeViewAll(): void {
    this._router.navigate(['/', this._currentHub.getHubURLTitle(), 'contribute']);
  }
  addProgram(): void {
    this._dialog
      .open(ProgramTemplatePickerDialogComponent, {
        backdropClass: 'click-through-dialog-backdrop',
        panelClass: 'fullscreen-dialog',
        data: { hubId: this.hub.id, mode: this.hub.mode }
      })
      .afterClosed()
      .pipe(
        filter((a) => a),
        map((ls) => this._router.navigate([this.hub.urlTitle, ls.id]))
      )
      .subscribe();
  }
}
